export const testimonials = [
  {
    id: "london-indian-family",
    name: "The S. Family",
    meta: "London-based Indian family",
    segment: "Second Home Buyer",
    quote: "We weren't just buying an apartment — we were buying the idea of winters in Dubai. ACRE understood that before we did.",
    journey: {
      lookingFor: "A second home in Dubai the whole family could use through the British winter, with school visits and long stays in mind.",
      unsure: "Whether to buy on the Palm or in a villa community — and how UK tax and ownership rules would interact with a Dubai purchase.",
      helped: "ACRE shortlisted three lifestyle-led options, arranged video walkthroughs around the family's working hours and introduced them to an independent cross-border tax adviser.",
      nextStep: "A Palm Jumeirah apartment is now reserved, with completion timed around the school calendar.",
    },
    featured: true,
  },
  {
    id: "new-jersey-indian-family",
    name: "The M. Family",
    meta: "New Jersey-based Indian family",
    segment: "Golden Visa Buyer",
    quote: "From New Jersey, the whole process felt distant — until ACRE made it feel like buying down the road.",
    journey: {
      lookingFor: "A Dubai property that qualified for the 10-year Golden Visa, with strong rental cover while the family remains in the US.",
      unsure: "How Golden Visa thresholds actually worked in practice, and which developers were reliable for off-plan delivery.",
      helped: "ACRE mapped visa-qualifying options across three districts, stress-tested rental assumptions and handled the paperwork chain end-to-end.",
      nextStep: "The family completed on a Downtown residence and their Golden Visa application is under way.",
    },
    featured: true,
  },
  {
    id: "mumbai-developer-group",
    name: "Mumbai-based Developer Group",
    meta: "Mumbai-based developer group",
    segment: "Land & JV Investor",
    quote: "We came for one plot and left with a structured view of the entire corridor. That is a different level of advisery.",
    journey: {
      lookingFor: "Land acquisition and potential joint-venture development exposure in the UAE, starting with Ras Al Khaimah.",
      unsure: "How plot zoning, title transfer and JV structures worked for foreign development groups entering the UAE.",
      helped: "ACRE opened doors to landowners and master developers, coordinated feasibility conversations and framed a structured partnership route.",
      nextStep: "The group is in advanced discussions on an Al Marjan-adjacent development partnership.",
    },
    featured: true,
  },
  {
    id: "manchester-couple",
    name: "J. & R. Whitfield",
    meta: "Manchester-based professional couple",
    segment: "Investment Buyer",
    quote: "The numbers were explained in pounds, in plain English, with the risks on the table. That won our trust.",
    journey: {
      lookingFor: "A first overseas investment with a yield meaningfully above UK buy-to-let.",
      unsure: "Currency exposure, service charges and whether advertised yields were realistic.",
      helped: "ACRE provided net-yield breakdowns after all costs and compared three districts on like-for-like numbers.",
      nextStep: "The couple completed on a Dubai Marina one-bedroom, now let on a 12-month tenancy.",
    },
  },
  {
    id: "dubai-expat-banker",
    name: "A. Mehta",
    meta: "Dubai-based finance professional",
    segment: "Investment Buyer",
    quote: "Even living here, I didn't have access to the launches ACRE showed me.",
    journey: {
      lookingFor: "An off-plan unit in a branded residence with a payment plan aligned to bonus cycles.",
      unsure: "Which branded launches genuinely held value versus which were marketing-led.",
      helped: "ACRE shared allocation-level access to two branded launches and an honest read on resale depth for each.",
      nextStep: "They reserved a Business Bay branded residence on a construction-linked plan.",
    },
  },
  {
    id: "singapore-family-office",
    name: "Singapore Family Office",
    meta: "Singapore-based family office",
    segment: "Family Office",
    quote: "ACRE speaks the language of allocation, not just sales.",
    journey: {
      lookingFor: "A diversified UAE residential allocation across two emirates.",
      unsure: "How to balance Dubai liquidity against Al Marjan growth exposure within one mandate.",
      helped: "ACRE structured a two-emirate shortlist with risk notes, comparable evidence and developer track-record summaries.",
      nextStep: "The family office deployed the first tranche across Dubai and Al Marjan Island residences.",
    },
  },
  {
    id: "birmingham-nri",
    name: "Dr. P. Nair",
    meta: "Birmingham-based NRI doctor",
    segment: "Second Home Buyer",
    quote: "I had two weekends a year to think about this. ACRE gave me back my weekends.",
    journey: {
      lookingFor: "A lock-up-and-leave apartment usable for family trips between the UK and Kerala.",
      unsure: "Management of the property while overseas and realistic short-let income.",
      helped: "ACRE matched a serviced, hotel-branded residence with an established operator and transparent management terms.",
      nextStep: "The buyer completed and placed the residence into the operator's managed programme.",
    },
  },
  {
    id: "toronto-entrepreneur",
    name: "S. Ghosh",
    meta: "Toronto-based entrepreneur",
    segment: "Golden Visa Buyer",
    quote: "The Golden Visa was the hook; the lifestyle is why we stayed.",
    journey: {
      lookingFor: "A visa-qualifying purchase that could double as a family base for extended stays.",
      unsure: "Whether to buy ready or off-plan to meet visa timelines.",
      helped: "ACRE modelled both routes, flagging where off-plan registration qualifies and where completed title is safer.",
      nextStep: "They chose a completed Saadiyat residence, and the family's visa process is under way.",
    },
  },
  {
    id: "london-finance-director",
    name: "E. Crawford",
    meta: "London-based finance director",
    segment: "Investment Buyer",
    quote: "A spreadsheet-friendly adviser. Rare in property.",
    journey: {
      lookingFor: "High-yield Dubai apartments to build a small portfolio over three years.",
      unsure: "Service-charge drag on net yields and exit liquidity in mid-market towers.",
      helped: "ACRE built a net-yield model per building, including charges, and ranked buildings by resale depth.",
      nextStep: "They completed two units in JVC and the Marina, with a third under review.",
    },
  },
  {
    id: "abu-dhabi-teacher-family",
    name: "The H. Family",
    meta: "Abu Dhabi-based teaching family",
    segment: "Family Home Buyer",
    quote: "They listened to how we actually live — school runs, grandparents, quiet weekends.",
    journey: {
      lookingFor: "A long-term family home on Yas Island near schools.",
      unsure: "Whether to buy now or continue renting in a rising market.",
      helped: "ACRE compared ownership costs against their current rent and shortlisted family-fit communities.",
      nextStep: "The family reserved a Yas Island townhouse close to their children's school.",
    },
  },
  {
    id: "delhi-business-owner",
    name: "R. Agarwal",
    meta: "Delhi-based business owner",
    segment: "Investment Buyer",
    quote: "Al Marjan was not on my radar. Now it is the most interesting part of my portfolio.",
    journey: {
      lookingFor: "Early-stage growth exposure beyond mature Dubai districts.",
      unsure: "Whether Al Marjan's growth story was substance or sentiment.",
      helped: "ACRE walked through the destination's hospitality pipeline, visitor data and comparable island precedents.",
      nextStep: "The investor acquired two branded island residences off-plan.",
    },
  },
  {
    id: "geneva-consultant",
    name: "C. Laurent",
    meta: "Geneva-based consultant",
    segment: "Second Home Buyer",
    quote: "Discreet, precise, and never once pushy.",
    journey: {
      lookingFor: "A private, high-floor Dubai residence for personal use.",
      unsure: "Which towers genuinely delivered the privacy the brochures promised.",
      helped: "ACRE filtered for genuine low-density, high-privacy buildings and arranged discreet viewings.",
      nextStep: "They completed on a full-floor residence on the Palm Crescent.",
    },
  },
  {
    id: "leeds-retired-couple",
    name: "M. & D. Fowler",
    meta: "Leeds-based retired couple",
    segment: "Lifestyle Buyer",
    quote: "At our age, simplicity matters. Everything was handled, step by step.",
    journey: {
      lookingFor: "A winter home in the sun with easy healthcare access and minimal upkeep.",
      unsure: "Inheritance considerations and how ownership passes to family.",
      helped: "ACRE introduced independent legal counsel for succession planning and matched a managed, low-maintenance community.",
      nextStep: "The couple settled into a Sobha Hartland II apartment for the winter season.",
    },
  },
  {
    id: "hong-kong-investor",
    name: "K. Wong",
    meta: "Hong Kong-based investor",
    segment: "Investment Buyer",
    quote: "The comparison tables sold me. Everything was evidenced.",
    journey: {
      lookingFor: "Tax-efficient property exposure outside Asian markets.",
      unsure: "How UAE transaction costs and ongoing taxes compared with Hong Kong and London.",
      helped: "ACRE provided a full acquisition-and-holding cost comparison across the three markets.",
      nextStep: "The investor completed their first UAE purchase and is reviewing a second in Ras Al Khaimah.",
    },
  },
];
